import { gql } from '@apollo/client'

const SEARCH_REJECT_REASONS = gql`
  query SEARCH_REJECT_REASONS($searchTerm: String) {
    searchRejectReasons(searchTerm: $searchTerm) {
      id
      name
      totalLeads
    }
  }
`

export default SEARCH_REJECT_REASONS
